module.exports = __webpack_public_path__ + "static/media/logo512.2d001bff.png";